import { Container } from "react-bootstrap";
import { getAllTables_Admin } from "../../../commons/Api";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import LaSpinner from "../../../components/spinner/LaSpinner.component";
import { handleErrorRouting } from "../../../commons/LaUtils";
import { useNavigate } from "react-router";

const AllTables = () => {
  const [loading, setLoading] = useState(true);
  const [tables, setTables] = useState<string>("");

  const navigate = useNavigate();

  useEffect(() => {
    getAllTables_Admin()
      .then((response) => {
        setTables(response.data);
      })
      .catch((error) => {
        handleErrorRouting(error, (url: string) => navigate(url));
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return loading ? (
    <Box sx={{ width: "100%", textAlign: "center" }}>
      <LaSpinner />
    </Box>
  ) : (
    <Container>
      <div>
        {tables.split("\n").map((i, key) => {
          return (
            <div key={key}>
              {i ? i : "--------------------------------------------"}
            </div>
          );
        })}
      </div>
    </Container>
  );
};
export default AllTables;
